/**
 * Map of route wrapper keys to provider components.
 * Used by AuthenticatedRoutes to wrap route elements (e.g. OrderProvider for /orders).
 * Add new wrappers here and set wrapper: "KeyName" on the route in routeConfig.js.
 */
import { OrderProvider } from "@components/Order/OrderContext";

export const ROUTE_WRAPPERS = {
  OrderProvider,
};
